var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseImage',{attrs:{"src":_vm.qrCode,"alt":"qr-code","adjust-size":"true","align":"right"}})}
var staticRenderFns = []

export { render, staticRenderFns }